import React, { useEffect, FC } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { IStockStatisticSonDetail } from "../../stockStatisticService"
import { useDictModel } from "../../../../base/dict/dictModel";
import { useStockStatisticDetailModel } from "./statisticDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";


export const DataTable: FC<RouterParamType> = ({ id, mode }) => {
    const { dataSource, selectedRowKeys, pgCfg, initPgCfg, loadData, setSelectedRowKeys, updateSearchParam } = useStockStatisticDetailModel()
    const { selectedNavId, replaceNav } = useNavModel();
    const { getTreeNodeName } = useDictModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language,setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const {  getTreeNodeOne } = useDictModel();

    useEffect(() => {
        loadData(initPgCfg, { materialCode: id })
        updateSearchParam({ materialCode: id })
    }, [])
    const onLook = (text: string) => {
        console.log(text, "跳到对应单据")
    }
    const columns: ColumnsType<IStockStatisticSonDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            fixed: 'left',
            render: (text, record, index) => `${index + 1}`
        }, {
            // title: "出入类型",
            title: Locale["Stock-io Type"],
            width: 120,
            dataIndex: 'ioFlag',
            fixed: 'left',
            render: text => text == 1 ? Locale["Stock in order"]: Locale["Outbound order"]
        }, {
            // title: '单据类型',
            title: Locale["Document  Type"],
            width: 120,
            fixed: 'left',
            dataIndex: 'tradeTypeCode',
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                }else{
                    return ""
                }
            }
        }, {
            // title: '单据编号',
            title: Locale["Document No."],
            width: 140,
            dataIndex: 'tradeCode',
            fixed: 'left',
            render: text => <span onClick={() => onLook(text)} className="click-span">{text}</span>
        }, {
            // title: '配件编码',
            title: Locale["Material Code"],
            width: 160,
            dataIndex: 'materialCode',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '配件名称',
            title: Locale["Material Name"],
            width: 160,
            dataIndex: 'materialName',
        }, {
            // title: '配件名称',
            title: Locale["Material Name En"],
            width: 160,
            dataIndex: 'materialNameEn',            
        }, {
            // title: '数量',
            title: Locale["Qty"],
            width: 160,
            dataIndex: 'num',
        }, {
            // title: '单价',
            title: Locale["Unit Price"],
            width: 160,
            dataIndex: 'price',
        }, {
            // title: '金额',
            title: Locale["Amount"],
            width: 160,
            dataIndex: 'amount',
        }, {
            // title: '仓库',
            title: Locale["Warehouse"],
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale["Shelf"],
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            // title: '时间',
            title: Locale["Creation Time"],
            width: 160,
            dataIndex: 'createTime',
        }, {
            // title: '制单员',
            title: Locale["Creator"],
            width: 160,
            dataIndex: 'createUser',
        }, {
            // title: '库管员',
            title: Locale["Storekeeper"],
            width: 160,
            dataIndex: 'createUser',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 160,
            dataIndex: 'note',
        }
    ];
    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStockStatisticSonDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.id as string]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
